import ShowcaseTabWrapper from "components/homepage/showcase-tab-wrapper";
import mockData from "mock/not-found";
import Container from "components/grid/container";

import styles from "./styles.module.css";

const NotFoundSearch = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <span className={styles.title}>Aradığınız Gayrimenkulu Hemen Bulun</span>
        <ShowcaseTabWrapper categoryTree={mockData.categoryTree} page="not-found" />
        <div className={styles.quickBox}>
          <a href="/satilik-konut" className={styles.box} title="Satılık Konutlar">
            <div className={styles.text}>Satılık Konutlar</div>
          </a>
          <a href="/kiralik-konut" className={styles.box} title="Kiralık Konutlar">
            <div className={styles.text}>Kiralık Konutlar</div>
          </a>
          <a href="/satilik-arsa" className={styles.box} title="Satılık Arsalar">
            <div className={styles.text}>Satılık Arsalar</div>
          </a>
          <a href="/kiralik-arsa" className={styles.box} title="Kiralık Arsalar">
            <div className={styles.text}>Kiralık Arsalar</div>
          </a>
          <a href="/satilik-konut?fiyat_analizi=firsat" className={styles.box} title="Jetfırsat Satılıklar">
            <div className={styles.text}>Jetfırsat Satılıklar</div>
          </a>
          <a href="/satilik-konut?fiyat_trendi=dusen" className={styles.box} title="Fiyatı Düşen Satılıklar">
            <div className={styles.text}>Fiyatı Düşen Satılıklar</div>
          </a>
          <a href="/kiralik-konut?fiyat_trendi=dusen" className={styles.box} title="Fiyatı Düşen Kiralıklar">
            <div className={styles.text}>Fiyatı Düşen Kiralıklar</div>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default NotFoundSearch;
